import { useSelector, useDispatch } from "react-redux";
import { logIn, logOut } from "../redux/slices/user";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const useUser = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  // Dispatch actions

  // destination: ruta a la que redirigir tras el login.
  // Si no se pasa (login directo sin ruta previa), va a /main.
  const logInUser = (payload, destination) => {
    dispatch(logIn(payload));
    navigate(destination ?? "../main", { replace: true });
  };

  const logOutUser = () => {
    dispatch(logOut());
  };

  //

  return { user, logInUser, logOutUser };
};
